import { z } from 'zod';
import type { BlockDefinition } from '../types';

export const testimonialSchema = z.object({
  quote: z.string().min(1).max(800),
  author: z.string().min(1).max(120),
  role: z.string().max(120).optional(),
  company: z.string().max(120).optional(),
  avatar: z.string().url().optional(),
  logo: z.string().url().optional(),
  theme: z.enum(['light', 'dark', 'lime']).default('light'),
});

export type TestimonialData = z.infer<typeof testimonialSchema>;

export function TestimonialRenderer({
  quote,
  author,
  role,
  company,
  avatar,
  logo,
  theme = 'light',
}: TestimonialData) {
  return (
    <section className={`v5-testimonial v5-testimonial--${theme}`}>
      <blockquote className="v5-testimonial-quote">
        <p>“{quote}”</p>
      </blockquote>
      <footer className="v5-testimonial-meta">
        {avatar ? <img className="v5-testimonial-avatar" src={avatar} alt={author} /> : null}
        <div className="v5-testimonial-author">
          <strong>{author}</strong>
          {(role || company) && (
            <span>
              {role}
              {role && company ? ' · ' : ''}
              {company}
            </span>
          )}
        </div>
        {logo ? <img className="v5-testimonial-logo" src={logo} alt={company ?? ''} /> : null}
      </footer>
    </section>
  );
}

export const testimonialBlock: BlockDefinition<TestimonialData> = {
  meta: {
    type: 'testimonial',
    label: 'Testimonio',
    description: 'Cita destacada con autor, rol, empresa y logos.',
    category: 'social-proof',
    icon: 'quote',
  },
  schema: testimonialSchema,
  defaults: {
    quote: 'Nos acompañaron en la venta de nuestra empresa familiar. El proceso fue impecable.',
    author: 'María García',
    role: 'CEO',
    company: 'Industrias Acme',
    theme: 'light',
  },
  fields: [
    { name: 'quote', label: 'Cita', type: 'textarea', required: true, max: 800 },
    { name: 'author', label: 'Autor', type: 'text', required: true },
    { name: 'role', label: 'Cargo', type: 'text' },
    { name: 'company', label: 'Empresa', type: 'text' },
    { name: 'avatar', label: 'Avatar', type: 'image' },
    { name: 'logo', label: 'Logo empresa', type: 'image' },
    {
      name: 'theme',
      label: 'Tema',
      type: 'select',
      options: [
        { label: 'Claro', value: 'light' },
        { label: 'Oscuro', value: 'dark' },
        { label: 'Lima', value: 'lime' },
      ],
    },
  ],
  Renderer: TestimonialRenderer,
};
